import styles from "./Footer.module.css";
import eiopaLogo from "../../assets/Logo_EIOPA.png";
import ebaLogo from "../../assets/Logo_EBA.png";
import esmaLogo from "../../assets/Logo_ESMA.png";
import strings from "../../loc/strings";

const authorityLogos = [
    {
        href: "https://www.eiopa.europa.eu/",
        src: eiopaLogo,
        alt: "European Insurance and Occupational Pensions Authority",
        imageClassName: styles.eiopaLogo,
    },
    {
        href: "https://www.eba.europa.eu/",
        src: ebaLogo,
        alt: "European Banking Authority",
        imageClassName: styles.ebaLogo,
    },
    {
        href: "https://www.esma.europa.eu/",
        src: esmaLogo,
        alt: "European Securities and Markets Authority",
        imageClassName: styles.esmaLogo,
    },
];

function Footer() {
    return (
        <footer className={styles.footer}>
            <nav className={styles.logos} aria-label="European supervisory authorities">
                {authorityLogos.map(({href, src, alt, imageClassName}) => (
                    <a
                        className={styles.logoLink}
                        key={href}
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`${alt} (opens in a new tab)`}
                    >
                        <img
                            className={`${styles.logoImage} ${imageClassName}`}
                            src={src}
                            alt={alt}
                        />
                    </a>
                ))}
            </nav>
            <div className={styles.copyright}>
                {strings.footerCopyright}
            </div>
        </footer>
    );
}

export default Footer;
